<template>
  <div class="amount-cars-available main-basic-info-price">
    <div class="amount-cars-available__logo" :class="{'b-empty shine-short': !loaded}">
      <img :src="getCompanyLogo"
           onerror="this.src='https://kadltd.me/kad/app/webroot/img/teeganmall/15757979411573992368next.png'"
           alt="">
    </div>
    <div class="amount-cars-available__content">
          <span class="amount-cars-available__title" :class="{'b-empty shine-short': !loaded}">
            {{ propNameCompany }}
          </span>

      <span class="amount-cars-available__text" :class="{'b-empty shine-short': !loaded}">
            {{ propCompanyAddress }}
          </span>
      <router-link v-if="showNewCarsReturnLink" :to="linkHrefNew"
                   class="amount-cars-available__link"
                   :class="{'b-empty shine-short': !loaded}">
        {{ propAmountCars.new_cars }} bílar á söluskrá
      </router-link>

      <router-link v-if="showStockCarsReturnLink && $store.state.showCarsInStock" :to="linkHrefStock"
                   class="amount-cars-available__link"
                   :class="{'b-empty shine-short': !loaded}">
        {{ propAmountCars.stock_cars }} Kjarabílar
      </router-link>

<!--      <span class="amount-cars-available__text"  v-text="propBrand"></span>-->

      <router-link v-if="showOldCarsReturnLink" :to="linkHrefOld"
                   class="amount-cars-available__link"
                   :class="{'b-empty shine-short': !loaded}">
        {{ propAmountCars.old_cars }} bílar á söluskrá
      </router-link>

      <a v-if="propLinkText" target="_blank" :href="linkHrefNew" class="amount-cars-available__link"
         :class="{'b-empty shine-short': !loaded}">
        {{ propLinkText }}
      </a>

    </div>
  </div>
</template>

<script>
import globalNewCar from "../../helpers/globalNewCar";

export default {
  props: {
    propLogo: {
      type: String,
      default: ''
    },
    propBrand: {
      type: String,
      default: ''
    },
    propNameCompany: {
      type: String,
      default: ''
    },
    propCompanyAddress: {
      type: String,
      default: ''
    },
    propAmountCars: {
      type: [Array, Object],
      default: null
    },
    propLinkText: {
      type: String,
      default: ''
    },
    loaded: {
      type: Boolean,
      default: false
    },
    company: {
      type: [Array, Object]
    }
  },
  computed: {
    getCompanyLogo(){
      if(this.$route.name === 'DealerCar'){
        return globalNewCar.getCompanyImg(this.propLogo);
      }
      return  this.propLogo;
    },
    showStockCarsReturnLink() {
      return this.propAmountCars && this.propAmountCars.stock_cars && this.propAmountCars.stock_cars > 0;
    },
    showNewCarsReturnLink() {
      return this.propAmountCars && this.propAmountCars.new_cars && this.propAmountCars.new_cars > 0;
    },
    showOldCarsReturnLink() {
      return this.propAmountCars && this.propAmountCars.old_cars && this.propAmountCars.old_cars > 0;
    },
    linkHrefStock() {
      if (!this.company) {
        return "";
      }
      let data = {company: [this.company.id]};

      let q = globalNewCar.setUrlParams(data);
      let props = this.$router.resolve({name: 'CarsInStock'});

      return props.href + q;
    },
    linkHrefOld() {
      if (!this.company) {
        return "";
      }
      let data = {companies: [this.company.id]};

      let q = globalNewCar.setUrlParams(data);
      let props = this.$router.resolve({name: 'OldCars'});

      return props.href + q;
    },
    linkHrefNew() {
      if (!this.company) {
        return "https://bilablogg.is";
      }
      let data = {company: [this.company.id]};

      let q = globalNewCar.setUrlParams(data);
      let props = this.$router.resolve({name: 'DealersCars'});

      return props.href + q;
    }
  }
}
</script>